import { Container, Grid } from "@mui/material";
import logoVitaleau from "../assets/images/Vital'_Eau-Logo-RVB.svg";
import MetaMaster from "../components/utils/MetaMaster";
import { Button } from "../stories/atoms/Button";

export default function Erreur() {
    return (
        <>
            <MetaMaster title={"Vital'eau - Erreur 404"} />
            <section className="section-show-pool-home section-error-page" id="accueil-histoire">
                <Container maxWidth="xl">
                    <Grid container>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <div className="vitaleau-section-error-page-content">
                                <img src={logoVitaleau} alt="Logo Vital'Eau" width={240} height={100} />
                                <h1 className="accueil-histoire-titre h1-inner" data-title="Page non trouvée">
                                    Page non trouvée
                                </h1>
                                <p className="">La page que vous recherchez n'éxiste pas !</p>
                                <Button label="Retour à l'accueil" secondary href={"/"} />
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </section>
        </>
    );
}
